import gql from 'graphql-tag'

export const fetchSuggestedCartQuery = gql(`
 query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_uid: [String]
    $pack_format: [String]
    $packaging: [String]
    $volume: [String]
    $filter_packaging: [String]
    $ship_tos: [String],
    $product_last: String
    $product_new: String
    $product_sale: String
    $product_recommended: String
    $product_special: String
  ) {
  getSuggestedCarts(
    search: $search,
    ship_tos: $ship_tos
    filter: {
      sku: { in: $sku }
      brand: { in: $brand }
      packaging: { in: $packaging }
      volume: { in: $volume }
      pack_format: {in : $pack_format}
      category_uid: { in: $category_uid }
      filter_packaging: { in: $filter_packaging }
       product_last: { eq: $product_last }
        product_new: { eq: $product_new }
        product_sale: { eq: $product_sale }
        product_recommended: { eq: $product_recommended }
        product_special: { eq: $product_special }
    }
    sort: $sort
  ) {
    categoryFilter {
    category_name
    category_id
    category_uid
    }
    has_packages
    items {
      summary_total_amount_wo_vat
      summary_total_amount_to_pay_for_goods
      summary_total_empty_deposit
      suggested_cart_total
      shipping_address {
        payer_name
        outlet_name
        street
        city
        country
        province
        postalcode
        sap_id
      }
      products {
        sku
        image
        name
        number_of_items_on_pallet
        number_of_items_on_layer
        total_units
        units
        promo_price_leaflet{
            promo_price_is_inside_delivery
        }
        product_last
        product_new
        product_sale
        product_recommended
        product_special
        number_of_layers
        number_of_pallets
        price_per_piece
        fixed_package {
          is_in_fixed_package
          fixed_sku {
            sku
          }
        }
        your_price_wo_vat
        your_price_w_vat
        is_in_flexible_package
           tags {
          value
          label
          color
        }
      }
    }
    aggregations {
      attribute_code
      count
      label
      options {
        label
        value
        count
      }
    }
  }
}
`)
